// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

import { KeycloakConfig } from 'keycloak-js';

export const environment: ApizConfig = {
  basehref: '/',
  configUrl: 'https://std.dev.apizsolutions.com/config-server/master/iupics-config-default.json',
  production: true,
  appName: 'Apiz',
  CUST_version: '{CUST_version}',
  STD_version: '4.1.5-mh',
  default_language: 'fr_FR',
  webSiteUrl: 'https://www.apizsolutions.com/',
  available_languages: ['ar_TN', 'ca_ES', 'en_GB', 'en_US', 'en', 'es_ES', 'fr_FR', 'fr', 'nl_NL'],
  config: {
    perfLogActive: true,
    backend: {
      auth: {
        url: 'https://keycloak.std.dev.apizsolutions.com',
        realm: 'apiz',
        clientId: 'iupics',
      },
      socketcluster: {
        hostname: 'https://std.dev.apizsolutions.com/socketcluster',
        port: undefined,
        secure: true,
      },
    },
  },
  constant: null,
  themes: null,
};

export interface ApizConfig {
  production: boolean;
  config: IAppConfig;
  constant: { [key: string]: any };
  themes: { [key: string]: any };
  [key: string]: any;
}

export interface IAppConfig {
  perfLogActive: boolean;
  backend: {
    auth?: KeycloakConfig;
    docserver?: {
      url: string;
      [key: string]: any;
    };
    socketcluster?: {
      hostname: string;
      port: number | undefined;
      secure: boolean;
      [key: string]: any;
    };
    version?: {
      url: string;
      [key: string]: any;
    };
    ws?: {
      url: string;
      paths: { [key: string]: string };
      [key: string]: any;
    };
  };
}
